import { IonContent } from '@ionic/react';
import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { PaymentModal } from '@/modals/Payment';
import { webCampaign } from '@/modules/webCampaign';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAISecond/components/Title';
import { PaywallAINumber } from '@/pages/Paywall/sections/AINumber';
import { PaywallGuaranteePeriod } from '@/pages/Paywall/sections/GuaranteePeriod';
import { PaywallSectionSelectPlan } from '@/pages/Paywall/sections/SelectPlan';

import { PaywallV6Styles } from './PaywallV6.styles';
import { SectionHowItWorks } from './sections/HowItWorks';
import { SectionMainImage } from './sections/MainImage';
import { SectionUsersReviews } from './sections/UsersReviews';

const PaywallV6: React.FC = () => {
  return (
    <PaywallV6Styles theme={webCampaign.getStaticTheme()}>
      <IonContent>
        <SectionMainImage />

        <PaywallSectionSelectPlan title={null} />

        <PaywallAINumber />

        <SectionUsersReviews />

        <SectionHowItWorks />

        <PaywallSectionSelectPlan
          title={
            <OwnAiTitle className="paywall-v6-title">
              Your Сustom{' '}
              <UiTypography variant="inherit" color="gradient" component="span">
                Super Dialogue Plan
              </UiTypography>{' '}
              is ready!
            </OwnAiTitle>
          }
        />

        <PaywallGuaranteePeriod />
      </IonContent>

      <PaymentModal />
    </PaywallV6Styles>
  );
};

export default PaywallV6;
